import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing an arrow back icon.
 *
 * @function
 * @param {Object} [props] - The component properties
 * @returns {JSX.Element} React component markup
 *
 * @see SvgIcon
 * @example
 * <ArrowBackIcon width={24} />
 */
const ArrowBackIcon = props => (
    <SvgIcon {...props}>
        <path
            d="M20,12c0,0.55-0.45,1-1,1H7.42l5.29,5.29c0.39,0.39,0.39,1.02,0,1.41C12.51,19.9,12.26,20,12,20s-0.51-0.1-0.71-0.29l-7-7
	C4.1,12.51,4,12.26,4,11.99s0.11-0.52,0.29-0.71l7-7c0.39-0.39,1.02-0.39,1.41,0c0.39,0.39,0.39,1.02,0,1.41L7.41,11H19
	C19.55,11,20,11.45,20,12z"
        />
    </SvgIcon>
)

ArrowBackIcon.defaultProps = defaultProps

export { ArrowBackIcon }
